import clsx from 'clsx'
import dayjs from 'dayjs'
import React from 'react'
import { Icon } from '..'
import { groupTransactionsByDate } from '../../utils'

import './TxnList.scss'

const TxnList = ({
   className,
   transactions,
   onTxnClick,
   ticker,
   isDarkTheme,
}) => {
   const groupedTransactions = React.useMemo(
      () => groupTransactionsByDate(transactions),
      [transactions]
   )

   const getIconName = txnType => {
      switch (txnType) {
         case 'RECEIVED':
            return 'download'
         case 'SENT':
            return 'upload'
         case 'SMART_CONTRACT_CALL':
            return 'bolt'
         default:
            return null
      }
   }

   const renderTransactionType = txnType => {
      switch (txnType) {
         case 'RECEIVED':
            return 'Received'
         case 'SENT':
            return 'Sent'
         case 'SMART_CONTRACT_CALL':
            return 'Smart Contract Call'
         default:
            return 'UNKNOWN'
      }
   }

   return (
      <div
         className={clsx('TxnList', isDarkTheme && 'TxnList--dark', className)}
      >
         {Object.entries(groupedTransactions).map(([date, txns], index) => (
            <div className="TxnList__history-day">
               <div className="TxnList__history-day-header">
                  <small>{index === 0 && 'History'}</small>
                  <small>{dayjs(date).format('MMM DD, YYYY')}</small>
               </div>
               <div className="TxnList__history-day-list">
                  {txns.map(txn => (
                     <div
                        className="TxnList__history-day-list-card"
                        role="button"
                        tabIndex={0}
                        onClick={() => onTxnClick(txn)}
                     >
                        <Icon
                           className="TxnList__history-day-list-card-icon"
                           name={getIconName(txn.type)}
                        />
                        <div className="TxnList__history-day-list-card-content">
                           <div className="TxnList__history-day-list-card-content-top">
                              <h3>{renderTransactionType(txn.type)}</h3>
                              <h3>
                                 {/* {txn.value} {ticker} */}
                              </h3>
                           </div>
                           <div className="TxnList__history-day-list-card-content-bottom">
                              {txn.sender ? 'From' : 'To'}:{' '}
                              {txn.sender || txn.recipient}
                           </div>
                        </div>
                     </div>
                  ))}
               </div>
            </div>
         ))}
      </div>
   )
}

export default TxnList
